<template>
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/01.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/02.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/03.jpg" />
      <img class="rule-icon" @click="$refs.rulesRef.open()" src="@/static/images/activityCenter/202406/04/21.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/04.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/05.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/06.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/07.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/08.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/09.png" />
      <div class="detaile" @click="detailPage(0)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/10.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/11.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/12.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/13.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/14.png" />
      <div class="detaile" @click="detailPage(1)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/15.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/16.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/17.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/18.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/19.png" />
      <div class="detaile" @click="detailPage(2)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202406/04/20.png" />
    </div>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>
  </div>
</template>

<script>
import config from '@/api/common';
import activityRules from '@/components/okActivity/rulePopup';

export default {
  components: {
    activityRules
  },
  data() {
    return {
      activityIds: [],
      activityList: [],
      preview: false,
      ruleText:
        '<h1 style="text-align:center;font-size: 22px;">规则详情</h1><h2 style="margin-top: 10px;">一、活动时间：</h2><p>2024年6月1日——2024年6月30日</p><p><br/></p><h2>二、活动对象：</h2><p>OK保已签约代理人</p><p><br/></p><h2>三、活动须知：</h2><p>出单OK保所有团险产品且保费满足要求</p><p><br/></p><h2>四、59988元阶梯现金奖</h2><h3>（一）活动内容</h3><p>活动期间内出单团险产品，累计保费达标可获得对应奖励</p><p>满1万元，奖励218元</p><p>满3万元，奖励888元</p><p>满10万元，奖励2888元</p><p>满50万元，奖励20088元</p><p>满100万元，奖励59988元</p><h3>（二）注意事项</h3><p>\n            1、&nbsp;\n    活动奖励取实现的最高档为主，不可重复叠加获得</p><p>\n            2、&nbsp;\n    奖励仅针对活动期间活动产品新单保费，保全不参与</p><p><br/></p><h2>五、首单有奖</h2><h3>（一）活动内容</h3><p>活动期间内开单保费首次大于或等于3000元奖励128元，仅限1次</p><h3>（二）注意事项</h3><p>奖励仅针对活动期间活动产品新单保费，保全不参与</p><p><br/></p><h2>六、单单有奖</h2><h3>（一）活动内容</h3><p>活动期间内出单任意团险产品，且每单保费大于或等于5000元，按照单数计算，每出一单，奖励88元现金，多出多得。</p><h3>（二）注意事项</h3><p>\n            1、&nbsp;\n    奖励仅针对活动期间活动产品新单保费，保全不参与</p><p>2、严禁恶意拆单，若发现多笔订单均为同一企业、同一出单人、同一产品，则视为同一个订单，仅发放一次奖励。</p><p><br/></p><h2>七、活动规则</h2><p>\n            1、&nbsp;\n    3项团险开单活动奖励可叠加。</p><p>2、如遇退保，OK保将扣回此单所有推广费及所有活动奖励。如发现同一代理人活动期间退保率或批减至最低承保人数超过2%，OK保有权追回所有奖励。</p><p>3、活动订单仅计算活动期间所出新单，保全不参与。</p><p>4、参加活动要求个人历史退保率&lt;2%，达标与否，将以活动开始前定版数据&nbsp;(即2024.5月30日零点系统数据)&nbsp;为准。</p><p>5、代理人若在奖励发放前离职或停职、账号已注销，则奖励不予结算。</p><p><br/></p><h2>八、活动奖励发放</h2><p>1、奖励将会在活动结束后的次月20日之后进行发放。产生退保的订单奖励不予结算。领取途径：进入APP我的页面——点击可提现——提现到银行卡。</p><p>2、退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行活动奖励发放。</p><p><br/></p><h2>九、活动参与资格、获奖资格的取消</h2><p>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</p><p>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</p><p>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</p><p>3、违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</p><p><br/></p><h2>十、免责条款</h2><p>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</p><p><h1></h1></p><p>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</p>'
    };
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;
    // 地址栏配置id
    let ids = this.$route.query.ids;
    if (ids) {
      this.activityIds = ids.split(',');
    } else if (config.env == '0' || config.env == '2') {
      // 本地、测试
      this.activityIds = ['1793121002607271937', '1793167061578010625', '1793167965795090434'];
    } else {
      // 正式
      this.activityIds = ['', '', ''];
    }
    this.getList();
  },

  methods: {
    // 获取活动详情
    getList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: this.activityIds.join(',')
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },

    // 明细
    detailPage(index) {
      if (this.$route.query.preview) return;
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: this.activityIds[index],
          type: this.activityList[index].type,
          calFactor: this.activityList[index].calFactor,
          productType: this.activityList[index].productType,
          mode: this.activityList[index].mode,
          status: this.activityList[index].status,
          conditionalIndicator: this.activityList[index].conditionalIndicator,
          activityType: 'group'
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .rule-icon {
      width: 64px;
      height: 64px;
      position: absolute;
      right: 20px;
      bottom: 0;
    }
    .detail-icon {
      width: 64px;
      height: 64px;
      position: absolute;
      right: 20px;
      bottom: 0;
    }
    .detaile {
      width: 500px;
      height: 102px;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -250px;
      border-radius: 51px;
    }
  }
}
</style>
